import React from 'react'
import styled from 'styled-components'
import { withNamespaces } from 'react-i18next'

import { NavLink } from 'react-router-dom'

import { Menu } from 'material-react-icons'

import logoInternational from '../images/logo_EN.png'
import logoRuServer from '../images/logo_RU.png'
import homeIcon from '../images/home_icon.png'
import interactionsIcon from '../images/touch_app_icon.png'
import contractIcon from '../images/receipt_icon.png'
import {getIsRuServer} from "../helpers/getIsRuServer";

const NavbarWrapper = styled.div`
  position: relative;

  &.active {
    margin-bottom: 76px;
  }
`

const StyledNavbarContainer = styled.div`
  margin: 0 auto;
  height: 76px;
  width: 100%;

  background-color: #fff;

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &.active {
    position: fixed;
    top: 0;
    left: 0;

    z-index: 1000;
  }
`

const StyledLogo = styled.div`
  width: ${getIsRuServer() ? 83 : 147}px;
  height: 32px;
  background: url(${getIsRuServer() ? logoRuServer : logoInternational}) no-repeat center center;
  background-size: 100% 100%;
`

const MenuButton = styled.div`
  position: absolute;
  top: 50%;
  right: 19px;
  width: 24px;
  height: 26px;

  transform: translateY(-50%);
`

const MenuBackground = styled.div`
  position: fixed;
  left: 100%;
  top: 76px;
  width: 100%;
  height: calc(100vh - 76px);
  background-color: #fff;

  display: flex;
  flex-direction: column;

  z-index: 1000;
  transition: left 0.4s;

  &.active {
    left: 0%;
  }
`

const StyledMenuList = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`

const StyledMenuItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  a {
    color: #727272;

    transition: all 0.2s;

    :hover {
      text-decoration: none;
    }
  }

  &:hover {
    color: #4c84ff;
    text-decoration: none;
  }

  .icon {
    margin: 0 auto 10px;
    width: 25px;
    height: 25px;
    background: url(${(props) => props.icon}) no-repeat center center;
    background-size: contain;
  }
`

const StyledLanguageSelect = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  color: #727272;
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;

  margin-bottom: 20px;

  .title {
    color: #2f2d2d;
    text-transform: uppercase;
    letter-spacing: 1.12px;
    padding-bottom: 5px;
    text-align: center;
  }

  .language {
    margin-left: 15px;

    &.active {
      color: blue;
    }
  }
`

const LanguageCaption = styled.div`
  margin: 10px auto;

  text-align: center;

  font-family: 'Open Sans', sans-serif;
  font-size: 20px;

  color: #2f2d2d;
  text-transform: uppercase;
  letter-spacing: 1.12px;
  text-align: center;
`

const StyledLogoutButton = styled.div`
  display: flex;
  justify-content: center;

  color: #727272;
  font-family: 'Open Sans', sans-serif;
  font-size: 23px;

  margin-bottom: 30px;
`

const renderMenuList = ({ t, toggle }) => {
  return (
    <StyledMenuList>
      <StyledMenuItem icon={homeIcon}>
        <NavLink
          activeStyle={{
            color: '#4c84ff'
          }}
          activeClassName="active"
          to="/dashboard/main"
          onClick={() => toggle()}
        >
          <div className="icon" />
          <div>{t('navigation:main')}</div>
        </NavLink>
      </StyledMenuItem>
      <StyledMenuItem icon={interactionsIcon}>
        <NavLink
          activeStyle={{
            color: '#4c84ff'
          }}
          activeClassName="active"
          to="/dashboard/interactions"
          onClick={() => toggle()}
        >
          <div className="icon" />
          <div>{t('navigation:interactions')}</div>
        </NavLink>
      </StyledMenuItem>
      <StyledMenuItem icon={contractIcon}>
        <NavLink
          activeStyle={{
            color: '#4c84ff'
          }}
          activeClassName="active"
          to="/dashboard/contracts"
          onClick={() => toggle()}
        >
          <div className="icon" />
          <div>{t('navigation:contracts')}</div>
        </NavLink>
      </StyledMenuItem>
    </StyledMenuList>
  )
}

const MobileNavbar = ({
  t,
  isOpen,
  toggle,
  lang,
  logout,
  changeLanguage,
  languages
}) => {
  const className = isOpen ? 'active' : ''

  return (
    <NavbarWrapper className={className}>
      <StyledNavbarContainer className={className}>
        <StyledLogo />
        <MenuButton onClick={toggle}>
          <Menu />
        </MenuButton>
      </StyledNavbarContainer>
      <MenuBackground className={className}>
        {renderMenuList({ t, toggle })}
        <LanguageCaption className="title">Language</LanguageCaption>
        <StyledLanguageSelect>
          {Object.entries(languages).map(([value, name]) => (
            <div
              key={value}
              onClick={() => {
                changeLanguage(value)
                // toggle()
              }}
              className={`language ${lang === value && 'active'}`}
            >
              {name}
            </div>
          ))}
        </StyledLanguageSelect>
        <StyledLogoutButton
          onClick={() => {
            toggle()
            logout()
          }}
        >
          {t('navigation:signOut')}
        </StyledLogoutButton>
      </MenuBackground>
    </NavbarWrapper>
  )
}

export default withNamespaces()(MobileNavbar)
